import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { DashboardApi, RejectedApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  dashboard_data: null,
  hierarchy_data: null
};

const DashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {
    setDashboardData(state, action) {
      state.dashboard_data = action.payload;
    },
    setHierarchyData(state, action) {
      state.hierarchy_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Dashboard Data
export const getDashboardData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: DashboardApi?.dashboardCard,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setDashboardData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setDashboardData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Dashboard Data failed', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Dashboard Data exception', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Dashboard Data
export const getHierarchyData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${DashboardApi?.hierarchyData}${data?.userId}`,
      method: 'get',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setHierarchyData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setHierarchyData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Hierarchy Data failed', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Hierarchy Data exception', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setDashboardData, setHierarchyData } = DashboardSlice.actions;
export default DashboardSlice.reducer;
